import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/Layout/ProtectedRoute';
import Navbar from './components/Layout/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Installations from './pages/Installations';
import InstallationDetails from './pages/InstallationDetails';
import CreateInstallation from './pages/CreateInstallation';
import EditInstallation from './pages/EditInstallation';
import CreateBackupConfig from './pages/CreateBackupConfig';
import BackupConfigs from './pages/BackupConfigs';
import CreateBackupConfigStandalone from './pages/CreateBackupConfigStandalone';
import EditBackupConfig from './pages/EditBackupConfig';
import BackupConfigDetails from './pages/BackupConfigDetails';
import BackupLogs from './pages/BackupLogs';
import BackupLogDetails from './pages/BackupLogDetails';
import AllBackupLogs from './pages/AllBackupLogs';
import ScheduleMasters from './pages/ScheduleMasters';
import ScheduleMasterForm from './pages/ScheduleMasterForm';
import SftpServerMasters from './pages/SftpServerMasters';
import SftpServerMasterForm from './pages/SftpServerMasterForm';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <div className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              
              {/* Dashboard */}
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              
              {/* Installations CRUD */}
              <Route path="/installations" element={<ProtectedRoute><Installations /></ProtectedRoute>} />
              <Route path="/installations/create" element={<ProtectedRoute><CreateInstallation /></ProtectedRoute>} />
              <Route path="/installations/edit/:uniqueId" element={<ProtectedRoute><EditInstallation /></ProtectedRoute>} />
              <Route path="/installations/:uniqueId" element={<ProtectedRoute><InstallationDetails /></ProtectedRoute>} />
              <Route path="/installations/:uniqueId/backup-config/new" element={<ProtectedRoute><CreateBackupConfig /></ProtectedRoute>} />
              
              {/* Backup Configs CRUD */}
              <Route path="/backup-configs" element={<ProtectedRoute><BackupConfigs /></ProtectedRoute>} />
              <Route path="/backup-configs/create" element={<ProtectedRoute><CreateBackupConfigStandalone /></ProtectedRoute>} />
              <Route path="/backup-configs/:configId" element={<ProtectedRoute><BackupConfigDetails /></ProtectedRoute>} />
              <Route path="/backup-configs/edit/:configId" element={<ProtectedRoute><EditBackupConfig /></ProtectedRoute>} />
              
              {/* Backup Logs */}
              <Route path="/backup-logs" element={<ProtectedRoute><AllBackupLogs /></ProtectedRoute>} />
              <Route path="/installations/:uniqueId/backup-logs" element={<ProtectedRoute><BackupLogs /></ProtectedRoute>} />
              <Route path="/backup-log/:logId" element={<ProtectedRoute><BackupLogDetails /></ProtectedRoute>} />
              
              {/* Masters */}
              <Route path="/schedules" element={<ProtectedRoute><ScheduleMasters /></ProtectedRoute>} />
              <Route path="/schedules/new" element={<ProtectedRoute><ScheduleMasterForm /></ProtectedRoute>} />
              <Route path="/schedules/edit/:scheduleId" element={<ProtectedRoute><ScheduleMasterForm /></ProtectedRoute>} />
              
              <Route path="/sftp-servers" element={<ProtectedRoute><SftpServerMasters /></ProtectedRoute>} />
              <Route path="/sftp-servers/new" element={<ProtectedRoute><SftpServerMasterForm /></ProtectedRoute>} />
              <Route path="/sftp-servers/edit/:serverId" element={<ProtectedRoute><SftpServerMasterForm /></ProtectedRoute>} />
              
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;